
import { footer } from './es/footer';
import { navigation } from './es/navigation';
import { easterCamp, christmasCamp, summerCamp, summerCampConfirmation } from './es/camps';
import { prices } from './es/prices';
import { montessori } from './es/montessori';
import { openHouse } from './es/openHouse';
import { extracurriculars } from './es/extracurriculars';
import { feedback } from "./es/feedback";
import { courses } from "./es/courses";
import { schoolCalendar } from './es/schoolCalendar';
import { birthdays } from './es/birthdays';
import { services } from './es/services';
import { admissions } from './es/admissions';
import { enrollmentForm } from './es/enrollmentForm';
import { enrollmentConfirmation } from './es/enrollmentConfirmation';
import { hero } from './es/hero';
import { trustBadges } from './es/trustBadges';
import { valueProposition } from './es/valueProposition';
import { testimonials } from './es/testimonials';
import { ctaSection } from './es/ctaSection';
import { gallery } from './es/gallery';
import { activities } from './es/activities';
import { principles } from './es/principles';
import { howWeTeach } from './es/howWeTeach';
import { trilingualModel } from './es/trilingualModel';
import { neasc } from './es/neasc';
import { visitBanner } from './es/visitBanner';
import { renewalForm } from './es/renewalForm';
import { renewalConfirmation } from './es/renewalConfirmation';
import { openHouseRegistration } from './es/openHouseRegistration';
import { admin } from './es/admin';

export const es = {
  navigation,
  footer,
  hero,
  trustBadges,
  valueProposition,
  howWeTeach,
  trilingualModel,
  neasc,
  gallery,
  activities,
  principles,
  testimonials,
  ctaSection,
  easterCamp,
  christmasCamp,
  summerCamp,
  summerCampConfirmation,
  prices,
  montessori,
  openHouse,
  openHouseRegistration,
  extracurriculars,
  feedback,
  courses,
  schoolCalendar,
  birthdays,
  services,
  admissions,
  enrollmentForm,
  enrollmentConfirmation,
  renewalForm,
  renewalConfirmation,
  admin,
  visitBanner,
  title: "Gándara International School",
  description: "Gándara International School, educación Montessori en Vigo",
  trilingual: {
    title: "Educación Trilingüe",
    metaDescription: "Nuestro enfoque trilingüe en Gándara International School",
    bookVisit: "Reserva una Visita",
    intro: {
      p1: "En Gándara International School, creemos en proporcionar una educación verdaderamente global que prepare a los estudiantes para el mundo conectado que heredarán.",
      p2: "Nuestro programa trilingüe sumerge a los estudiantes en español, inglés y gallego, creando oportunidades naturales para la adquisición de idiomas y la comprensión cultural."
    },
    sections: {
      immersion: {
        title: "Inmersión Natural en Idiomas",
        p1: "En lugar de enseñar idiomas como materias aisladas, nuestro enfoque integra los idiomas a lo largo de la jornada escolar. Los niños experimentan diferentes idiomas en contexto, estableciendo conexiones y desarrollando fluidez de manera natural.",
        p2: "Cada idioma tiene tiempos y espacios dedicados, con profesores nativos o altamente competentes que crean un ambiente lingüístico auténtico."
      },
      languages: {
        title: "Tres Idiomas, Una Comunidad",
        p1: "El español sirve como nuestro idioma principal de instrucción, conectando a los estudiantes con nuestra comunidad local y la cultura española.",
        p2: "El inglés y el gallego se integran en todo el plan de estudios, con asignaturas y actividades específicas realizadas en cada idioma para garantizar una exposición y práctica equilibradas."
      },
      benefits: {
        title: "La Ventaja Multilingüe",
        intro: "La investigación muestra constantemente que los niños que aprenden varios idiomas desde una edad temprana desarrollan ventajas cognitivas significativas:",
        list: [
          "Mejora de las habilidades de resolución de problemas y pensamiento creativo",
          "Mejor memoria y procesamiento de información",
          "Mayor conciencia cultural y empatía",
          "Mejor rendimiento académico en todas las materias",
          "Mayores oportunidades educativas y profesionales futuras"
        ],
        conclusion: "Estos beneficios se extienden mucho más allá de las habilidades lingüísticas, apoyando el desarrollo integral y preparando a los estudiantes para el éxito en una sociedad cada vez más global."
      },
      methodology: {
        title: "Nuestro Enfoque",
        content: "Nuestra metodología trilingüe está diseñada teniendo en cuenta las capacidades naturales de adquisición del lenguaje de los niños. Los niños pequeños tienen una capacidad innata para absorber idiomas sin la confusión que a menudo experimentan los adultos. A través de experiencias inmersivas, actividades atractivas y exposición constante, los estudiantes desarrollan habilidades de comunicación seguras en los tres idiomas."
      },
      environment: {
        title: "Un Entorno de Apoyo",
        p1: "Creamos una atmósfera positiva y alentadora donde los estudiantes se sienten seguros practicando nuevos idiomas sin miedo a cometer errores. El aprendizaje es activo, contextual y significativo.",
        p2: "Nuestro reducido tamaño de clases asegura que cada niño reciba atención individualizada y amplias oportunidades para practicar el habla y la escucha en cada idioma."
      }
    }
  },
  about: {
    title: "Sobre Nosotros",
    subtitle: "Conoce a nuestro equipo de acompañantes dedicados a la educación y el crecimiento de cada niño y niña",
    bookVisit: "Reserva una visita",
    story: {
      title: "Nuestra Historia",
      content: "Gándara nació en 2013 del sueño de dos familias que buscaban una educación diferente para sus hijos: un espacio donde el respeto, la naturaleza y la libertad fueran los cimientos del aprendizaje. Lo que empezó como una pequeña escuela en una finca de Gondomar se ha convertido en un colegio internacional acreditado por NEASC, con un equipo de acompañantes apasionados y una comunidad de familias que comparten la misma visión."
    },
    mission: {
      title: "Nuestra Misión",
      content: "Acompañar a cada niño y niña en su desarrollo integral, respetando sus ritmos y procesos naturales, en un entorno de naturaleza donde el aprendizaje activo, la convivencia multilingüe y la curiosidad son el motor de cada día."
    },
    values: {
      title: "Nuestros Valores",
      items: [
        { title: "Respeto", description: "Por los ritmos, las emociones y los procesos únicos de cada niño y niña." },
        { title: "Autonomía", description: "Fomentamos la independencia y la confianza en las propias capacidades." },
        { title: "Comunidad", description: "Familias, acompañantes y niños crecemos juntos en un proyecto compartido." },
        { title: "Naturaleza", description: "Nuestros más de 5.000 m² de finca son un aula viva donde aprender y explorar." },
        { title: "Reinversión", description: "Gándara no reparte beneficios: cada euro se reinvierte en el colegio para ofrecer la mejor educación posible." }
      ]
    },
    video: {
      title: "Descubre nuestra escuela"
    },
    teamTitle: "Nuestro Equipo",
    photoComingSoon: "Foto próximamente",
    back: "Volver",
    team: [
      {
        name: "Patricia Méndez",
        role: "Codirectora",
        description: "Soy, con Pablo, fundadora de Barkibu, el proyecto que nos permite apoyar Gándara y en el que cuidamos de los animales y de sus familias. Nos enamoramos de Gándara porque nuestras hijas crecen aquí y creemos que es la mejor educación posible: por eso la apoyamos y acompañamos a las familias en su día a día."
      },
      {
        name: "Pablo Pazos",
        role: "Codirector",
        description: "Patricia y yo somos los fundadores de Barkibu, el proyecto que nos permite apoyar Gándara y en el que cuidamos de los animales y de sus familias. De Gándara nos enamoramos como familia: nuestras hijas estudian aquí y creemos que esta es la mejor educación posible. Por eso la apoyamos y la gestionamos para que dure muchos años."
      },
      {
        name: "Iago Ferraz",
        role: "Fundador, director pedagógico y acompañante",
        description: "Montar una escuela diferente fue mi sueño durante quince años: un lugar de convivencia basado en el respeto y el amor hacia los niños y niñas, en plena naturaleza. Hoy ese sueño es Gándara, donde aprendo y disfruto cada día con los mejores maestros: los propios niños. Formar parte de esto me hace sentir profundamente agradecido."
      },
      {
        name: "Verónica Álvarez",
        role: "Subdirectora",
        description: "Gándara es para mí mucho más que un trabajo: es mi segundo hogar. Me hace feliz formar parte de esta pequeña gran familia y aprender cada día de los valores que aquí se respiran: solidaridad, libertad, integridad y creatividad."
      },
      {
        name: "Alba Couse",
        role: "Acompañante de Infantil",
        description: "Soy maestra de Educación Infantil con mención en Audición y Lenguaje, y curso el máster Montessori 0-6 del International Montessori Institute. Conocí Gándara haciendo aquí mis prácticas y me quedé: este curso acompaño Infantil, con una mirada especial hacia la alta sensibilidad y el cuidado."
      },
      {
        name: "Carmen Aguilar",
        role: "Acompañante de Ciclo 1",
        description: "Soy maestra de Educación Primaria con especialidad en Lengua Inglesa. Mi experiencia como docente y tutora me ha permitido acompañar a niños y niñas con diferentes ritmos, intereses y necesidades. Continúo formándome en metodologías activas y, especialmente, en la metodología Montessori. Afronto esta nueva etapa con mucha ilusión y el compromiso de acompañar a cada niño y niña con sensibilidad, respeto y cariño."
      },
      {
        name: "David Torres",
        role: "Acompañante de Ciclo 2 y responsable de Ciencias",
        description: "Soy oceanógrafo y divulgador científico: llevo más de diez años acercando la ciencia a públicos de todas las edades, con formación en ciencias Montessori, robótica educativa y gamificación. Me apasiona que el asombro por la naturaleza sea la puerta del aprendizaje, del mar a la huerta."
      },
      {
        name: "Patricia Iglesias",
        role: "Acompañante de Infantil y English en Ciclo 1",
        description: "Filóloga de formación y educadora de vocación: llegué a la educación por amor a las lenguas y me quedé por las niñas y los niños. Llevo años enseñando inglés en Infantil a través del juego, con formación en pedagogías activas, Montessori y educación en la naturaleza, y un enfoque donde el vínculo emocional va siempre primero."
      },
      {
        name: "Paula Alonso",
        role: "Comedor y acompañante de Infantil",
        description: "Soy maestra de Educación Infantil y he pasado toda mi vida profesional entre la educación respetuosa y la naturaleza: coordiné durante años el área de 3-6 de un espacio de educación libre y dirigí un centro de ocio infantil. En Gándara acompaño el comedor y a Infantil, donde la mesa también es escuela: comer con calma, conversar y cuidarnos."
      },
      {
        name: "Sandra Amigo",
        role: "Acompañante de Ciclo 2 y especialista de inglés",
        description: "Soy maestra especializada en lengua extranjera, trilingüe inglés-castellano-catalán y Forest School Teacher. He coordinado el inglés en escuelas de más de 250 alumnos y proyectos educativos en la universidad, siempre con metodologías activas y Montessori. Mi motor es construir un mundo mejor a través de una educación que fomente la empatía y el respeto hacia todo lo que nos rodea."
      },
      {
        name: "Yoli Paz",
        role: "Limpieza y cuidado de los espacios",
        description: "Cuido de que los espacios de Gándara estén limpios y acogedores cada día. Un ambiente cuidado también educa."
      }
    ]
  }
};
